"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexConcat = exports.convertBlockNumberToLeftPadHex = exports.etherV6Id = void 0;
const ethers = __importStar(require("ethers"));
// logic to generate same output as ethers.id() of ethers@v6
function etherV6Id(input) {
    return ethers.utils.keccak256(ethers.utils.toUtf8Bytes(input));
}
exports.etherV6Id = etherV6Id;
function convertBlockNumberToLeftPadHex(blockNumber) {
    const blockNumberInHex = ethers.utils.hexlify(blockNumber);
    return ethers.utils.hexZeroPad(blockNumberInHex, 32);
}
exports.convertBlockNumberToLeftPadHex = convertBlockNumberToLeftPadHex;
function hexConcat(inputArray) {
    return ethers.utils.hexlify(ethers.utils.concat(inputArray));
}
exports.hexConcat = hexConcat;
